<template>
  <div id="login" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- <h1 style="text-align: center">英语单词后台管理系统</h1> -->
    <div :style="bstyle">
      <el-card>
        <div slot="header" style="text-align: center">
          <span>URead</span>
        </div>
        <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="auto"
                 label-position="left">
          <el-form-item label="账号" prop="account">
            <el-input v-model="ruleForm.account" maxlength=20 autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" maxlength=20 v-model="ruleForm.password" autocomplete="off"
                      @keyup.enter.native="submitForm()"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right">
            <el-button type="primary" @click="submitForm()">登 陆</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div style="position: absolute; bottom:10px; width:99%; text-align: center">
      <a href="https://beian.miit.gov.cn/">
        粤ICP备2021161918号
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  props: {},
  data() {
    return {
      bstyle: {
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
        position: 'fixed',
        width: '400px',
        height: '400px',
        margin: "auto auto"
      },
      fullscreenLoading: false,
      ruleForm: {
        account: '',
        password: ''
      }
    }
  },
  mounted: function () {
    console.log(localStorage.getItem("stoken"))
    if (localStorage.getItem("stoken") != null) {
      this.$router.replace({name: 'index'})
    }
  },
  methods: {
    submitForm: function () {
      var _this = this;
      if (_this.ruleForm.account.length == 0) {
        _this.$message("请输入账号");
        return;
      }
      if (_this.ruleForm.password.length == 0) {
        _this.$message("请输入密码");
        return;
      }
      _this.fullscreenLoading = true;
      let path = "/auth/login";
      let data = {type: 'public', username: _this.ruleForm.account, password: _this.ruleForm.password};
      _this.request("POST", path, data, function (data) {
        localStorage.setItem("stoken", data.token);
        localStorage.setItem("refreshToken", data.srefreshToken);
        _this.$router.replace({name: 'index'});
      });
    }
  }
}
</script>

<style>

</style>